// localStorage helpers
import { DEFAULT_UPGRADES } from "./upgrades";

const KEY = "zombieCollector3D_save_v1";

const DEFAULT_SAVE = {
  coins: 0,
  totalScore: 0,
  unlockedLevels: [1],
  completedLevels: [],
  upgrades: { ...DEFAULT_UPGRADES },
  highScores: {},
  wave: 1, // endless mode — increments every time you clear Level 5
  highestWave: 1,
};

export function loadSave() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_SAVE };
    const parsed = JSON.parse(raw);
    return {
      ...DEFAULT_SAVE,
      ...parsed,
      upgrades: { ...DEFAULT_UPGRADES, ...(parsed.upgrades || {}) },
    };
  } catch (e) {
    return { ...DEFAULT_SAVE };
  }
}

export function saveGame(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch (e) {
    // noop
  }
}

export function resetSave() {
  localStorage.removeItem(KEY);
  return { ...DEFAULT_SAVE };
}
